// extracted by mini-css-extract-plugin
module.exports = {"button":"index-button-12ntb","scale":"index-scale-fg1Nr","brightness":"index-brightness-DYKee","rotate":"index-rotate-YzmrF"};